import { frontendURL } from 'dashboard/helper/URLHelper';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/internal-chat'),
      name: 'internal_chat_index',
      component: Index,
      meta: {
        permissions: ['administrator', 'agent'],
        featureFlag: 'internal_chat',
      },
    },
  ],
};
